import { render, staticRenderFns } from "./BoxTarea.vue?vue&type=template&id=7427ecb2"
import script from "./BoxTarea.vue?vue&type=script&lang=js"
export * from "./BoxTarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports